import React, { useState } from 'react';
import './i18n'; // Importa tu configuración de i18n
import { useTranslation } from 'react-i18next';
import './languageSwitcher.css'; // Importa los estilos

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState('es'); // Idioma predeterminado

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setSelectedLanguage(lng);
  };

  return (
    <div className="switch-container">
      <button
        className={`switch-button ${selectedLanguage === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
      <button
        className={`switch-button ${selectedLanguage === 'es' ? 'active' : ''}`}
        onClick={() => changeLanguage('es')}
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;